import styled from "styled-components"


export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    margin: 0px;
    padding: 0px;
    border: 0px;
    top: 70px;
    bottom: 0px;
    left: 0;
    right: 0;
`;

export const IframeContainer = styled.iframe`
    position: absolute;
    width: 100%;
    height: calc(100% - 70px);
    margin: 0px;
    padding: 0px;
    border: 0px;
`;

export const Header = styled.div`
    width: 100%;
    height: 30px;
    margin: 0px;
    padding: 20px 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #074c86;
    /* z-index: 1000; */
`;

export const BackButton = styled.button`
    height: 16px;
    width: 16px;
    /* 
    border: none;
    font-size: 20px;
    font-weight: bold; */
    /* color: #z */
    background-color: transparent;
    border: solid #FFFFFF;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    &:hover{
        cursor: pointer;
    }
`;
